import React from "react";

import {CircularProgress, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import OpportunityCard from "../Cards/OpportunityCard";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";


function getMonthsAndYears(numberOfMonths) {
    const months = [];
    const today = new Date(); // Текущая дата и время

    for (let i = 0; i < numberOfMonths; i++) {
        const date = new Date(today);
        date.setMonth(today.getMonth() + i);
        const formattedMonthYear = date.toLocaleDateString('ru-RU', {month: 'numeric', year: 'numeric'});
        months.push(formattedMonthYear);
    }
    return months;
}


class OpportunitiesToGoCalendar extends React.Component {
    render() {
        if (!this.props.report) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                    overflowY: 'scroll'
                }}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                >
                    <Chip
                        sx={{
                            minWidth: '200px',
                            width: '200px'
                        }}
                    >
                        Сделка
                    </Chip>
                    {
                        getMonthsAndYears(this.props.numberOfMonth).map(
                            (month) => (
                                <Chip
                                    sx={{
                                        minWidth: '65px',
                                        width: '65px',
                                    }}
                                >
                                    {month}
                                </Chip>
                            )
                        )
                    }
                </Stack>
                <Divider />
                {
                    Object.values(this.props.report).sort((a, b) => a.forecast > b.forecast).map(
                        (value) => {
                            return(
                                <>
                                    <Stack
                                        spacing={1}
                                    >
                                        {
                                            value.calendar.map(
                                                (row, index) => {
                                                    return(
                                                        <Stack
                                                            direction={'row'}
                                                            spacing={1}
                                                        >
                                                            {
                                                                index === 0?
                                                                    <OpportunityCard
                                                                        opportunity={value.opportunity}
                                                                        nano={true}
                                                                        sx={{
                                                                            minWidth: '200px',
                                                                            width: '200px'
                                                                        }}
                                                                    />:
                                                                    <Box
                                                                        sx={{
                                                                            minWidth: '200px',
                                                                            width: '200px'
                                                                        }}
                                                                    >

                                                                    </Box>
                                                            }

                                                            {
                                                                row.map(
                                                                    (month, index) => (
                                                                        <Chip
                                                                            variant={month === 0?'soft':'solid'}
                                                                            sx={{
                                                                                minWidth: '65px',
                                                                                width: '65px',
                                                                                '&::after': !(month === this.props.norma || month === 0)?
                                                                                    {
                                                                                        content: '""',
                                                                                        position: 'absolute',
                                                                                        backgroundColor: 'var(--variant-softBg, var(--joy-palette-neutral-softBg, var(--joy-palette-neutral-100)))',
                                                                                        top: 0,
                                                                                        bottom: 0,
                                                                                        right: index?0:null,
                                                                                        left: index?null:0,
                                                                                        width: ((1 - (month / this.props.norma)) * 100).toFixed(0).toString() + '%',
                                                                                        borderTopRightRadius: index?'var(--_Chip-radius)':null,
                                                                                        borderBottomRightRadius: index?'var(--_Chip-radius)':null,
                                                                                        borderTopLeftRadius: index?null:'var(--_Chip-radius)',
                                                                                        borderBottomLeftRadius: index?null:'var(--_Chip-radius)',
                                                                                    }:
                                                                                    {},
                                                                            }}
                                                                            color={month>0?value.tail?'lime':value.forecast?'primary':'success':'neutral'}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    zIndex: 1005,
                                                                                    position: 'relative',
                                                                                    display: 'flex',
                                                                                    alignContent: 'center',
                                                                                    justifyContent: 'center',
                                                                                }}
                                                                            >
                                                                                {month === this.props.norma || month === 0?'':(month * 8).toFixed(0)}
                                                                            </div>
                                                                        </Chip>
                                                                    )
                                                                )
                                                            }
                                                        </Stack>
                                                    )
                                                }
                                            )
                                        }
                                    </Stack>
                                    <Divider />
                                </>
                            )
                        }
                    )
                }
            </Stack>
        );
    }
}

export default OpportunitiesToGoCalendar
